<template>
  <ul id="rolelist">
    <li @click="clickLi(item)" v-for="(item, index) in items" :key="index">
      {{ item.name }}
    </li>
  </ul>
</template>
<script>
export default {
  data() {
    return {
      items: [],
    };
  },
  methods: {
    getList() {
      this.axios({
        method: "post",
        url: this.axios.bm + "/role/list",
        data: {},
      }).then((res) => {
        var data = res.data.data.dataList;
        this.items = data;
      });
    },
    clickLi(row) {
      this.$emit("role", row);
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style>
#rolelist li {
  padding: 10px 4px;
}
#rolelist li:hover {
  cursor: pointer;
  background: #d1eff9;
}
</style>


// WEBPACK FOOTER //
// src/components/diaodu/roleList.vue